import React, { useContext, useEffect } from 'react'
import AppTable from '../table/AppTable'
import { useMutation } from '@apollo/client';
import { GET_ADD_TICKETS_ERROR } from '../../../features/ErrorDashboard/api/ErrorQuery';
import moment from 'moment';
import ToasterWithMessage from '../toaster';
import styles from './AddTicketsError.module.css'
import { CircularProgress } from '@mui/material';
import {  formatDates } from '../../../helper';
import { globalContext } from '../../../Provider/AppProvider';



const AddTicketsError = (props: any) => {
    const {
          rowsPerPage,
          currentPage,
          setCurrentPage,
          checking,
          setChecking,
          addTicketErrorList,
          setAddTicketErrorList,
          columnTypes,
          setColumnTypes,
          sortType,
          setSortType,
          selected,
          setSelected,
          datesForApiCall,
          selectedStartDate,
          selectedEndDate,
          GenerateAddTicketsErrorHeadCells,
          handleChangeRowsPerPage,
          handlePageChange
    } = props;

    const {error} = ToasterWithMessage();
    const {globalState,handleGlobalState} = useContext<any>(globalContext)
    const [getAddTicketsError,{loading}] = useMutation(GET_ADD_TICKETS_ERROR,{
        fetchPolicy: 'no-cache',
        onCompleted: (errorData) => {
            setAddTicketErrorList(errorData);
        },
        onError: (err) => {
          error("Something went wrong while fetching error data!");
        }
    })

    const callAddTicketsErrorApi = () => {
        const startdate = datesForApiCall.fromdate;
        const enddate = datesForApiCall.enddate;
        const formattedDates = formatDates(startdate, enddate);
        // const payloadEndDate = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
        if(moment(startdate).isSameOrBefore(enddate,'day')){
            let payload = {};
            if(columnTypes){
                payload = {
                    "startDate": formattedDates.formattedStartDate,
                    "endDate": formattedDates.formattedEndDate,
                    "limit": rowsPerPage,
                    "offset": (currentPage -1)*rowsPerPage,
                    "orderBy": sortType,
                    "orderColumn": columnTypes,
                    "status" :globalState.errorStatus.addTicket
                } 
            }else {
                payload = {
                    "startDate": formattedDates.formattedStartDate,
                    "endDate": formattedDates.formattedEndDate,
                    "limit": rowsPerPage,
                    "offset": (currentPage -1)*rowsPerPage,
                    "orderBy": sortType,
                    "status" :globalState.errorStatus.addTicket
                }
            }
            getAddTicketsError({
                variables: payload
            })
            const tempState = {...globalState};
            tempState.trigger.addTicketError = false;
            handleGlobalState(tempState);
            return;
        }else {
            // error("Fromdate must be less than todate");
            return;
        }
    }
    useEffect(() => {
        callAddTicketsErrorApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedStartDate,
       selectedEndDate,
       sortType,
       columnTypes,
       rowsPerPage,
       currentPage,
       globalState.errorStatus.addTicket,
    ])
    useEffect(() => {
        if(globalState.trigger.addTicketError===true){
        callAddTicketsErrorApi();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[globalState.trigger.addTicketError])
  return (
    <>
    {
        loading
    ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
    :
    <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handlePageChange={handlePageChange}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        list={addTicketErrorList}
        // list={dummyerrorData}
        tableTitle="addTicketsError"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateAddTicketsErrorHeadCells}
    />
    }
    </>
  )
}

export default AddTicketsError